import { Card, Descriptions, Typography } from 'antd';
import React, { memo } from 'react';
import {
    renderApplicantStatus,
    ALL_APPLICANT_STATUS_FIELDS_FOR_DISPLAY
} from './utils'; 
import { FaClipboardList, FaRegListAlt, FaMoneyCheckAlt, FaUserCheck, FaInfoCircle } from 'react-icons/fa';

const { Title } = Typography;

// IconTitle helper 
const SectionTitle = ({ icon, text }) => {
    const IconComponent = icon;
    return (
        <span style={{ display: 'flex', alignItems: 'center', fontSize: '1rem', fontWeight: 500, color: 'rgba(0, 0, 0, 0.88)' /* AntD default dark text */ }}>
            <IconComponent style={{ marginRight: '8px', verticalAlign: 'middle' }} size="1.1em" />
            {text}
        </span>
    );
};

// Main Card Title IconTitle
const MainCardIconTitle = ({ icon, text, level = 5 }) => {
    const IconComponent = icon;
    return (
        <Title level={level} style={{ display: 'flex', alignItems: 'center', marginBottom: 0, fontSize: '1.25rem', color: '#1890ff' }}>
            <IconComponent style={{ marginRight: '8px', verticalAlign: 'middle' }} size="1.2em" />
            {text}
        </Title>
    );
};

/**
 * Component for displaying comprehensive applicant status information
 * @param {Object} props - Component props
 * @param {Object} props.data - Applicant data object
 */
const StatusInfo = memo(({ data }) => {
    if (!data) return null;

    const statusItemsToDisplay = ALL_APPLICANT_STATUS_FIELDS_FOR_DISPLAY.map(fieldConfig => ({
        label: fieldConfig.label,      // Use the custom label from the config object
        value: data[fieldConfig.key],  // Get the value from the data using the key
        key: fieldConfig.key,          // Keep the key for filtering and React keys
    })).filter(item => data.hasOwnProperty(item.key)); // Filter out statuses not present in the data object

    const applicationProcessStatuses = statusItemsToDisplay.filter(item =>
        ['registrationStatus', 'admissionRequirementsStatus', 'preferredExamAndInterviewApplicationStatus', 'admissionAdminFirstStatus', 'admissionExamDetailsStatus', 'approvedExamFeeStatus', 'approvedExamInterviewResult','reservationFeePaymentStepStatus'].includes(item.key)
    );

    const approvalAndEnrollmentStatuses = statusItemsToDisplay.filter(item =>
        ['admissionApprovalAdminStatus', 'enrollmentRequirementsStatus', 'voucherApplicationStatus', 'enrollmentApprovalAdminStatus'].includes(item.key)
    );
    const overallAndAccountStatuses = statusItemsToDisplay.filter(item =>
        ['officialEnrolled', 'status'].includes(item.key)
    );
    const otherStatuses = statusItemsToDisplay.filter(item =>
        !applicationProcessStatuses.some(s => s.key === item.key) &&
        !approvalAndEnrollmentStatuses.some(s => s.key === item.key) &&
        !overallAndAccountStatuses.some(s => s.key === item.key)
    );

    const renderStatusSection = (title, items, icon) => {
        if (!items || items.length === 0) return null;
        return (
            <Descriptions
                title={title ? <SectionTitle icon={icon || FaRegListAlt} text={title} /> : null}
                bordered
                column={1}
                size="small"
                style={{ marginBottom: 12 }}
                contentStyle={{ paddingTop: '8px', paddingBottom: '8px' }}
                labelStyle={{ paddingTop: '8px', paddingBottom: '8px' }}
            >
                {items.map((item) => (
                    <Descriptions.Item key={item.key} label={item.label}>
                        {renderApplicantStatus(item.key, item.value)}
                    </Descriptions.Item>
                ))}
            </Descriptions>
        );
    };

    return (
        <Card
            className="mb-4"
            title={<MainCardIconTitle icon={FaClipboardList} text="Application Status Summary" level={4} />}
            bodyStyle={{ paddingTop: 16 }}
        >
            {renderStatusSection("Admission Process", applicationProcessStatuses, FaRegListAlt)}
            {renderStatusSection("Enrollment Process", approvalAndEnrollmentStatuses, FaUserCheck)}

            {renderStatusSection("Overall & Account Status", overallAndAccountStatuses, FaInfoCircle)}
            {/* {otherStatuses.length > 0 && renderStatusSection("Additional Statuses", otherStatuses, FaInfoCircle)} */}
            {!statusItemsToDisplay.length && <p>No status information available.</p>}
        </Card>
    );
});

export default StatusInfo;